import { render, staticRenderFns } from "./djgbpk.vue?vue&type=template&id=2f4aeafa&scoped=true"
import script from "./djgbpk.vue?vue&type=script&lang=js"
export * from "./djgbpk.vue?vue&type=script&lang=js"
import style0 from "./djgbpk.vue?vue&type=style&index=0&id=2f4aeafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4aeafa",
  null
  
)

export default component.exports